const INITIAL_STATE = {
  language: { values: [], error: null, loading: false },
};

export default function (state = INITIAL_STATE, action) {
  return {
    ...state,
    language: { values: action.payload, error: null, loading: true },
  };
}
